var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column"},[_c('p',{staticClass:"d-flex justify-content-center company"},[_vm._v("© By Astrid Beauty Salon "+_vm._s(new Date().getFullYear())+" ")]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"d-flex justify-content-center created"},[_vm._v(" Built by ©"),_c('a',{attrs:{"href":"https://gauntletdesigns.com"}},[_vm._v(" Gauntlet Designs")])])
}]

export { render, staticRenderFns }